import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export interface useGroupResult {
  groupBy: string | null
  setGroupBy: (groupBy: string) => void
}

const useGroup = (initialGroupBy = ''): useGroupResult => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const [groupBy, setCurrentGroupBy] = useState(
    searchParams.has('groupBy') ? searchParams.get('groupBy') : initialGroupBy,
  )

  useEffect(() => {
    // Update URL with the current page
    const updatedSearchParams = new URLSearchParams(window.location.search)

    // Clear the sort by if it's null or an empty string
    if ((groupBy ?? '') === '') {
      updatedSearchParams.delete('groupBy')
    } else {
      updatedSearchParams.set('groupBy', groupBy ?? '')
    }

    // Replace the current state in the history without adding a new entry
    window.history.replaceState(null, '', `${window.location.pathname}?${updatedSearchParams.toString()}`)
  }, [groupBy])

  const setGroupBy = (groupBy: string) => {
    setCurrentGroupBy(groupBy)
  }

  return {
    groupBy,
    setGroupBy,
  }
}

export default useGroup
